import { Controller } from "@hotwired/stimulus"

// data-controller="selectable"
//   <input type="checkbox" data-selectable-target="all" data-action="change->selectable#toggleAll">
//   <input type="checkbox" data-selectable-target="item" data-action="change->selectable#refresh" name="ids[]" value="...">
//   <div data-selectable-target="toolbar" hidden>
//     <span data-selectable-target="count"></span>
//   </div>
//
// Tracks how many item checkboxes are checked. Shows the toolbar when ≥ 1 is
// selected, updates the count, and toggles the master checkbox state.
export default class extends Controller {
  static targets = ["all", "item", "toolbar", "count"]

  connect() {
    this.refresh()
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.itemTargets.forEach((cb) => { cb.checked = checked })
    this.refresh()
  }

  refresh() {
    const selected = this.itemTargets.filter((cb) => cb.checked)
    if (this.hasToolbarTarget) {
      this.toolbarTarget.hidden = selected.length === 0
    }
    if (this.hasCountTarget) {
      this.countTarget.textContent = String(selected.length)
    }
    if (this.hasAllTarget) {
      this.allTarget.checked = selected.length > 0 && selected.length === this.itemTargets.length
      this.allTarget.indeterminate = selected.length > 0 && selected.length < this.itemTargets.length
    }
  }
}
